import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import { formatCurrency } from 'Helpers/UiHelper';

const MarketCostTable = ({ data }) => {
  if (!data || data.length === 0) {
    return <p className="text-center text-muted">No data available</p>;
  }

  // Sort by average cost descending (highest first)
  const sortedData = [...data].sort((a, b) => (b.avgCost || 0) - (a.avgCost || 0));

  return (
    <div style={{ overflowX: 'auto' }}>
      <Table striped hover size="sm" className="mb-0">
        <thead>
          <tr>
            <th>Market</th>
            <th className="text-end">Total</th>
            <th className="text-end">Confirmed</th>
            <th className="text-end">Avg Cost</th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((row) => (
            <tr key={row.market}>
              <td>{row.market}</td>
              <td className="text-end">{row.total}</td>
              <td className="text-end">{row.confirmed}</td>
              <td className="text-end">{formatCurrency(row.avgCost)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

MarketCostTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      market: PropTypes.string.isRequired,
      total: PropTypes.number.isRequired,
      confirmed: PropTypes.number.isRequired,
      avgCost: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default MarketCostTable;
